import React, { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { colours } from "@/theme/colours";
import clsx from "clsx";
import { useClassroomLayoutStore } from "@/stores/v2/classroomLayoutStore";

interface InactiveTileLayoutProps {
	children: React.ReactNode;
}

const InactiveTileContentLayout: FC<InactiveTileLayoutProps> = ({ children }) => {
	const tileSize = useClassroomLayoutStore((state) => state.tileSize);

	return (
		<Flex
			padding={clsx({
				"12px 0 8px": tileSize === "md" || tileSize === "lg",
				"4px 0 8px": tileSize === "sm",
			})}
			gap={"4px"}
			flexDirection={"column"}
			alignItems={"center"}
			textAlign={"center"}
			fontSize={12}
			color={colours.neutrals[500]}
		>
			{children}
		</Flex>
	);
};

export default InactiveTileContentLayout;
